export default {"src":"/_next/static/media/section5-img.fa835dc4.svg","height":379,"width":520,"blurWidth":0,"blurHeight":0};